var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkInitialLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 27,
    viewBox: "0 0 277 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.342 26.3998H129.511V9.79817C129.511 4.92481 125.342 4.9248 125.342 4.9248V26.3998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.059 26.3998H103.889V9.79817C103.889 4.92481 108.059 4.9248 108.059 4.9248V26.3998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.397 0.774414H113.018C108.122 0.774414 108.122 4.92481 108.122 4.92481H125.306C125.306 4.92481 125.293 0.774414 120.397 0.774414Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6284 26.5581H42.8103V9.9077C42.8103 5.02003 38.6284 5.02002 38.6284 5.02002V26.5581Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8638 26.5581H24.0456V9.9077C24.0456 5.02003 19.8638 5.02002 19.8638 5.02002V26.5581Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18184 26.5581H0V9.9077C0 5.02003 4.18184 5.02002 4.18184 5.02002V26.5581Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6649 0.857422H9.14052C4.2329 0.857422 4.23291 5.02001 4.23291 5.02001H19.5725C19.5725 5.02001 19.5725 0.857422 14.6649 0.857422Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8196 0.857422H24.342C19.4317 0.857422 19.4316 5.02001 19.4316 5.02001H38.7298C38.7298 5.02001 38.7298 0.857422 33.8196 0.857422Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7035 5.68344V0.88916H55.3802C50.3739 0.88916 50.3739 5.61055 50.3739 5.61055H67.2505V18.0282C67.2505 20.6143 65.9542 22.2745 62.9846 22.2745C60.015 22.2745 50.3577 22.0909 50.3577 22.0909V5.48368C50.3577 5.48368 46.0972 6.22334 46.0972 9.36284V26.5315H64.1046C68.7394 26.5315 71.6981 23.7619 71.6981 18.7786L71.7035 5.68344Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.602 5.55457V0.754883H84.2814C79.2724 0.754883 79.2724 5.47898 79.2724 5.47898H96.1517V17.8966C96.1517 20.48 94.8526 22.1429 91.8857 22.1429C88.9188 22.1429 79.2588 21.9566 79.2588 21.9566V5.35211C79.2588 5.35211 74.9902 6.09176 74.9902 9.22856V26.4H92.9977C97.6351 26.4 100.591 23.6303 100.591 18.6444L100.602 5.55457Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M183.015 10.4696C187.811 8.91093 189.145 12.9776 189.145 12.9776L177.367 16.8077C172.568 18.3664 171.234 14.2997 171.234 14.2997L183.015 10.4696Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M189.143 26.4999H193.441V5.91066C193.441 0.889166 189.143 0.88916 189.143 0.88916V26.4999Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171.325 26.4999H167.026V5.91066C167.026 0.889166 171.325 0.88916 171.325 0.88916V26.4999Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M159.104 4.98107V0.75H142.101C137.11 0.75 137.11 4.98107 137.11 4.98107H159.104Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M137.424 22.1689V26.4H154.426C159.417 26.4 159.417 22.1689 159.417 22.1689H137.424Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153.411 9.89537C158.166 8.38909 159.455 12.4238 159.455 12.4238C159.455 12.4238 145.404 16.7786 143.11 17.5048C138.356 19.0084 137.067 14.9764 137.067 14.9764C137.067 14.9764 151.122 10.6189 153.411 9.89537Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M159.491 22.0208V12.3914C159.491 12.3914 163.739 12.0793 163.739 15.7509C163.739 15.9365 163.739 18.1717 163.739 18.3735C163.741 22.0208 159.491 22.0208 159.491 22.0208Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M137.046 5.1748V14.9495C137.046 14.9495 132.798 15.2615 132.798 11.59C132.798 11.4044 132.798 9.0239 132.798 8.83293C132.796 5.1748 137.046 5.1748 137.046 5.1748Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M251.18 5.66439V0.873047H234.867C229.864 0.873047 229.864 5.59154 229.864 5.59154H246.73V18.0015C246.73 20.586 245.435 22.2452 242.467 22.2452C239.499 22.2452 229.848 22.0618 229.848 22.0618V5.46475C229.848 5.46475 225.59 6.20395 225.59 9.34152V26.4997H243.586C248.218 26.4997 251.175 23.7317 251.175 18.7515L251.18 5.66439Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M222.303 5.67753V0.88916H206C201 0.88916 201 5.60472 201 5.60472H217.855V18.007C217.855 20.5899 216.561 22.2481 213.595 22.2481C210.629 22.2481 200.983 22.0647 200.983 22.0647V5.47801C200.983 5.47801 196.728 6.21676 196.728 9.35238V26.4999H214.713C219.342 26.4999 222.297 23.7336 222.297 18.7566L222.303 5.67753Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M270.916 0.88916C275.825 0.88916 276.166 5.37341 276.166 5.37341C276.166 5.37341 262.079 5.4475 259.716 5.45014C254.807 5.45014 254.467 0.952667 254.467 0.952667C254.467 0.952667 268.554 0.891806 270.916 0.88916Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M263.728 26.44H267.908V9.7941C267.908 4.90772 263.728 4.90771 263.728 4.90771V26.44Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkInitialLogo);
export default __webpack_public_path__ + "static/media/dark-initial-logo.3a4c4307b2669f1e1810ebda902867fb.svg";
export { ForwardRef as ReactComponent };